//ModalAssetForEdit
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Checkbox,
  Divider,
  Space,
  Upload,
  Button,
  Form,
  Input,
  notification,
  DatePicker,
  Radio,
  message,
  Tabs,
  Modal,
  Tag,
  Select,
  Image,
} from "antd";
import Compressor from "compressorjs";
import dayjs from "dayjs";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import {
  DELETE_CUSTOMER_ASSET,
  DELETE_CUSTOMER_ONE_ASSET,
  DELETE_IMAGE,
  GET_LOAD_IMAGE,
  POST_EDIT_ASSET,
  POST_UPLOAD_IMAGE,
} from "../../../API/apiUrls";
import ModalEditOwner from "./ModalEditOwner";
const { Option } = Select;
const { confirm } = Modal;

function ModalAssetForEdit({
  open,
  onClose,
  handleLoadDataNew,
  index,
  provinces,
  dataForEdit,
  datasendForEdit,
  datas,
  handleLoadPaegeFornewData,
}) {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm(); // form หลัก
  const [formaddperson] = Form.useForm(); // เพิ่มเจ้าของทรัพย์
  const [formradio] = Form.useForm(); // radio, checkbox
  const [seizedForm] = Form.useForm(); // ติดอายัด
  const [mortgageForm] = Form.useForm(); // ติดจำนอง, ติดขายฝาก

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const token = localStorage.getItem("TOKEN");
  const [getimages, setGetImages] = useState([]); // รูปภาพทั้งหมด
  const [dataEdit, setDataEdit] = useState({ ...datasendForEdit }); //
  const [ch, setCh] = useState([]); // checkbox ติดอายัด,ติดจำนอง,ติดขายฝาก
  const [showForm, setShowForm] = useState(false); // แสดงฟอร์มเพิ่มเจ้าของทรัพย์
  const [assetCustomer, setAssetCustomer] = useState([]); // state ไว้เก็บข้อมูลเจ้าของทรัพย์

  // แก้ไขเจ้าของทรัพย์
  const [modaleditowner, setModalEditOwner] = useState(false);
  const [dataeditowner, setDataEditOwner] = useState([]);

  // เลือกอำเภอ
  const [districts, setDistricts] = useState([]);
  const [subdistricts, setSubdistricts] = useState([]);
  const [zipcode, setZipcode] = useState("");

  // Radio
  const [radioValue, setRadioValue] = useState(2); // state ไว้เก็บค่าของ Radio

  // images
  const [fileListLocation, setFileListLocation] = useState([]);
  const [fileListMap, setFileListMap] = useState([]);
  const [fileListAssessment, setFileListAssessment] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [allImg, setAllImg] = useState([]);

  // console.log("datas", datas);
  // console.log("datasendForEdit", datasendForEdit);
  // console.log("dataForEdit", dataForEdit);
  // console.log("datasendForEdit?.investigation", dataForEdit?.investigation);
  // console.log("dataEdit", dataEdit);
  // console.log("radioValue", radioValue);
  // console.log("assetCustomer", assetCustomer);
  // console.log("showForm", showForm);
  // console.log("index", index);
  // console.log("ch", ch);
  // console.log("getimages", getimages);

  const mapLandAreaStatus = (status) => {
    if (!status) return [];
    return [String(status)];
  };

  useEffect(() => {
    if (datasendForEdit?.investigation !== null) {
      setDataEdit({ ...datasendForEdit });
      // ตั้งค่า checkbox ติดอายัด,ติดจำนอง,ติดขายฝาก
      // ✅ แปลงให้แน่ใจว่าเป็น array
      const landAreaStatus = mapLandAreaStatus(datasendForEdit?.landAreaStatus);
      console.log("landAreaStatus", landAreaStatus);
      setCh((datasendForEdit?.landAreaStatus).toString());
      formradio.setFieldsValue({
        landAreaStatus: mapLandAreaStatus(datasendForEdit?.landAreaStatus),
      });
      // ตั้งค่า radio
      setRadioValue(datasendForEdit?.assetCustomer?.length > 0 ? 1 : 2);
      // ตั้งค่า images
      setGetImages(
        datasendForEdit?.areaImage?.length > 0 ? datasendForEdit?.areaImage : []
      );
      // ตั้งค่า จังหวัด อำเภอ ตำบล รหัสไปรษณีย์
      form.setFieldsValue({
        numberLand: datasendForEdit?.numberLand || null,
        numberLandlawang: datasendForEdit?.numberLandlawang || null,
        landPrice: datasendForEdit?.landPrice || null,
        nameMap: datasendForEdit?.nameMap || null,
        lat: datasendForEdit?.lat || null,
        lng: datasendForEdit?.lng || null,
        provinceName: datasendForEdit?.provinceName || null,
        districtName: datasendForEdit?.districtName || null,
        subdistrictName: datasendForEdit?.subdistrictName || null,
        zipcode: datasendForEdit?.zipcode || null,
      });

      if ((datasendForEdit?.landAreaStatus).toString() !== "4") {
        if ((datasendForEdit?.landAreaStatus).toString() === "1") {
          seizedForm.setFieldsValue({
            caseNumber: datasendForEdit?.assetSeized?.caseNumber || null,
            enforcementOfficer:
              datasendForEdit?.assetSeized?.enforcementOfficer || null,
            judgementOwner:
              datasendForEdit?.assetSeized?.judgementOwner || null,
            officeName: datasendForEdit?.assetSeized?.officeName || null,
            valuationPrice:
              datasendForEdit?.assetSeized?.valuationPrice || null,
          });
        } else if (
          (datasendForEdit?.landAreaStatus).toString() === "2" ||
          (datasendForEdit?.landAreaStatus).toString() === "3"
        ) {
          mortgageForm.setFieldsValue({
            // ...datasendForEdit?.assetLandArea[index]?.assetMortgage,
            mortgageCreditor:
              datasendForEdit?.assetMortgage?.mortgageCreditor || null,
            mortgageDebt: datasendForEdit?.assetMortgage?.mortgageDebt || null,
            redemptionDate: datasendForEdit?.assetMortgage?.redemptionDate
              ? dayjs(datasendForEdit?.assetMortgage?.redemptionDate)
              : dayjs(),
            contractDate: datasendForEdit?.assetMortgage?.contractDate
              ? dayjs(datasendForEdit?.assetMortgage?.contractDate)
              : dayjs(),
          });
        }
      }

      // if (datasendForEdit?.province) {
      //     handleProvinceChange(datasendForEdit?.province);
      // }
      if (datasendForEdit?.district) {
        handleDistrictChange(datasendForEdit?.district);
      }
      if (datasendForEdit?.subdistrict) {
        handleSubdistrictChange(datasendForEdit?.subdistrict);
      }
      // ตั้งค่า เจ้าของทรัพย์
      setAssetCustomer(
        datasendForEdit?.contractLandCustomer?.length > 0
          ? datasendForEdit?.contractLandCustomer
          : []
      );

      formaddperson.setFieldsValue({
        cuscod:
          datasendForEdit?.assetCustomer?.length > 0
            ? datasendForEdit?.assetCustomer[0]?.cuscod
            : "",
        snam:
          datasendForEdit?.assetCustomer?.length > 0
            ? datasendForEdit?.assetCustomer[0]?.snam
            : "",
        fname:
          datasendForEdit?.assetCustomer?.length > 0
            ? datasendForEdit?.assetCustomer[0]?.fname
            : "",
        lname:
          datasendForEdit?.assetCustomer?.length > 0
            ? datasendForEdit?.assetCustomer[0]?.lname
            : "",
        relation:
          datasendForEdit?.assetCustomer?.length > 0
            ? datasendForEdit?.assetCustomer[0]?.relation
            : "",
      });
    } else {
    }
  }, [datasendForEdit, form, formaddperson, formradio]);

  // อัพเดตข้อมูลเจ้าของทรัพย์
  const handledataNewOwner = (values) => {
    console.log("handledataNewOwner", values);
    setAssetCustomer((prev) =>
      prev.map((item) => (item.acId === values?.acId ? { ...values } : item))
    );
  };

  // ----------------------------------------- Start handleFormChange ----------------------------------------- //
  const handleFormChange = (index, field, values) => {
    // การกรอกข้อมูลในฟอร์ม
    console.log("field", field);

    let updatedItem = { ...dataEdit, [field]: { ...values } };

    if (field === "seizedData") {
      // ติดอายัด
      delete updatedItem.mortgageData;
      updatedItem = {
        ...dataEdit,
        assetSeized: {
          ...values,
          assetSeizedId: dataEdit?.assetSeized?.assetSeizedId,
          landAreaId: dataEdit?.assetSeized?.landAreaId,
        },
      };
    }

    if (field === "mortgageData") {
      // ติดจำนอง, ติดขายฝาก
      delete updatedItem.seizedData;
      updatedItem = {
        ...dataEdit,
        assetMortgage: {
          ...values,
          assetMortgageId: dataEdit?.assetMortgage?.assetMortgageId,
          landAreaId: dataEdit?.assetMortgage?.landAreaId,
        },
      };
    }
    console.log("updatedItem", updatedItem);

    // updatedItem[index] = updatedItem;
    setDataEdit(updatedItem);
  };
  // ----------------------------------------- Start handleFormChange ----------------------------------------- //

  // ----------------------------------------- Start Images ----------------------------------------- //
  const handleChangeLocation = async (img, FileList, setFileList, type) => {
    // 2
    for (const removedFile of FileList.filter(
      (file) => file.status === "removed"
    )) {
      if (
        allImg.some(
          (img) =>
            img.imageCompressedFile.name === removedFile.name &&
            img.type === type
        )
      ) {
        const updatedAllImg = allImg.filter(
          (img) =>
            !(
              img.imageCompressedFile.name === removedFile.name &&
              img.type === type
            )
        );
        setAllImg(updatedAllImg);
      }
    }
    const filteredFileList = img.fileList.filter(
      (file) => file.size <= 5000000
    );
    setFileList(filteredFileList);
    setLoading(false);
  };
  const handleChangeMap = async (img, FileList, setFileList, type) => {
    // 3
    for (const removedFile of FileList.filter(
      (file) => file.status === "removed"
    )) {
      if (
        allImg.some(
          (img) =>
            img.imageCompressedFile.name === removedFile.name &&
            img.type === type
        )
      ) {
        const updatedAllImg = allImg.filter(
          (img) =>
            !(
              img.imageCompressedFile.name === removedFile.name &&
              img.type === type
            )
        );
        setAllImg(updatedAllImg);
      }
    }
    const filteredFileList = img.fileList.filter(
      (file) => file.size <= 5000000
    );
    setFileList(filteredFileList);
    setLoading(false);
  };
  const handleChangeAssessment = async (img, FileList, setFileList, type) => {
    // 4
    for (const removedFile of FileList.filter(
      (file) => file.status === "removed"
    )) {
      if (
        allImg.some(
          (img) =>
            img.imageCompressedFile.name === removedFile.name &&
            img.type === type
        )
      ) {
        const updatedAllImg = allImg.filter(
          (img) =>
            !(
              img.imageCompressedFile.name === removedFile.name &&
              img.type === type
            )
        );
        setAllImg(updatedAllImg);
      }
    }
    const filteredFileList = img.fileList.filter(
      (file) => file.size <= 5000000
    );
    setFileList(filteredFileList);
    setLoading(false);
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const beforeUpts = async (file, ty) => {
    try {
      setLoading(true);
      const compressedFile = await compressImage(file, ty);
      return Promise.resolve(compressedFile);
    } catch (error) {
      console.error("Image compression error:", error);
      message.error("Image compression failed.");
      return Promise.reject(); // เปลี่ยนให้ return Promise.reject() เมื่อไม่สามารถบีบอัดได้
    }
  };

  const compressImage = async (ez, types) => {
    var image = {};
    return new Promise(async (resolve) => {
      if (types !== 7) {
        if (ez.size > 4000000) {
          console.log("4m ไม่ให้ส่ง");
          resolve(true); // บอกให้ระบบทราบว่ากระบวนการเสร็จสิ้น
        } else {
          let quality;
          if (ez.size >= 2500000 && ez.size <= 4000000) {
            quality = 0.1;
          } else if (ez.size >= 2000000 && ez.size <= 2499999) {
            quality = 0.15;
          } else if (ez.size >= 1500000 && ez.size <= 1999999) {
            quality = 0.2;
          } else if (ez.size >= 1000000 && ez.size <= 1499999) {
            quality = 0.3;
          } else {
            quality = 0.5;
          }

          try {
            // ใช้ Promise เพื่อบีบอัดรูปภาพ
            const compressedFile = await new Promise((resolveCompress) => {
              new Compressor(ez, {
                quality: quality,
                success: (result) => {
                  resolveCompress(result);
                },
              });
            });

            const fileOptions = {
              type: compressedFile.type,
              lastModified: Date.now(),
            };
            const compressedFileAsFile = new File(
              [compressedFile],
              ez.name,
              fileOptions
            );
            image.imageCompressedFile = compressedFileAsFile;
            image.type = types;
            allImg.push(image);
            //setAllImg((prevAllImg) => [...prevAllImg, image]);

            // ตรงนี้คือการ resolve ไฟล์ที่ถูกบีบอัด
            resolve(image);
          } catch (error) {
            console.error("Image compression error:", error);
            resolve(true); // บอกให้ระบบทราบว่ากระบวนการเสร็จสิ้น
          }
        }
      } else {
        // ... (โลจิกสำหรับ type 7)
        image.imageCompressedFile = ez;
        image.type = types;
        allImg.push(image);
        //setAllImg((prevAllImg) => [...prevAllImg, image]);
        resolve(true); // บอกให้ระบบทราบว่ากระบวนการเสร็จสิ้น
      }
    });
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };
  // ----------------------------------------- End Images ----------------------------------------- //
  // --- ฟังก์ชันดึงข้อมูลอำเภอ ตำบล รหัสไปรษณีย์ --- //
  const handleProvinceChange = async (prov_code) => {
    console.log("Selected province code:", prov_code);
    const params = {
      prov_code: String(prov_code),
    };
    console.log("params", params);

    try {
      setLoading(true);
      const response = await axios.get(
        "https://shark-app-j9jc9.ondigitalocean.app/lawyer/lands/districts",
        { params }
      );
      console.log("อำเภอ", response?.data);

      setDistricts(response.data); // เก็บข้อมูลที่ได้จาก backend
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
    setSubdistricts([]); // รีเซ็ตตำบลทุกครั้งที่เปลี่ยนจังหวัด
    setZipcode(""); // รีเซ็ตรหัสไปรษณีย์
  };
  const handleDistrictChange = async (selectedDistCode) => {
    // หา object ของอำเภอที่ตรงกับ dist_code
    console.log("selectedDistCode", selectedDistCode);

    const selectedDist = districts?.find(
      (d) => d.dist_code === selectedDistCode
    );

    if (!selectedDist) return;

    const { prov_code, dist_code } = selectedDist;

    console.log("Selected prov_code:", prov_code);
    console.log("Selected dist_code:", dist_code);

    const params = {
      prov_code,
      dist_code,
    };
    console.log("params", params);

    // fetch ข้อมูลตำบลต่อจาก backend
    try {
      setLoading(true);
      const response = await axios.get(
        "https://shark-app-j9jc9.ondigitalocean.app/lawyer/lands/sub-districts",
        { params }
      );
      console.log("ตำบล", response?.data);

      setSubdistricts(response.data); // เก็บข้อมูลที่ได้จาก backend
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }

    setZipcode(""); // รีเซ็ตรหัสไปรษณีย์
  };
  const handleSubdistrictChange = (subdistrict_code) => {
    const sub = subdistricts.find((s) => s.code === subdistrict_code);
    if (sub) {
      setZipcode(sub.zipcode); // ดึง zipcode จากตำบล
    }
  };
  // --- ฟังก์ชันดึงข้อมูลอำเภอ ตำบล รหัสไปรษณีย์ --- //

  // ฟังก์ชัน set ค่า checkbox ติดอายัด ติดจำนอง ติดขายฝาก ไม่ติดภาระ
  const handlecheckedValues = (index, values) => {
    // checkbox ติดอายัด,ติดจำนอง,ติดขายฝาก
    const newData = [datasendForEdit];
    newData[index] = { ...newData[index], landAreaStatus: values[0] };
    console.log("values", values);
    console.log("values[0]", values[0]);
    const checked = values[0];
    console.log("checked", checked);
    console.log("newData", newData);
    setCh(checked);
    setDataEdit(newData);
  };
  const handleCancel = () => {
    setPreviewVisible(false);
  };
  const handleFormChanges = (_, allValues) => {
    setFormData(allValues);
  };
  const handleClose = () => {
    onClose(false);
  };

  // บันทึกเจ้าของทรัพย์
  const onFinish = (values) => {
    console.log("ข้อมูลเจ้าของทรัพย์:", values);
    setAssetCustomer((prev) => [
      ...prev,
      {
        landId: datasendForEdit?.landAreaId,
        acId: 0,
        relation: values?.relation,
        assetType: 2,
        assetCustomer: {
          ...values,
          acId: 0,
        },
      },
    ]);
    formaddperson.resetFields(); // reset form หลังบันทึก
    setShowForm(false);
    setRadioValue(2);
  };
  // กรณียกเลิกเพิ่มเจ้าของทรัพย์ จะรีเซตค่าในฟอร์ม formaddperson
  const onCancels = () => {
    formaddperson.resetFields([]); // รีเซ็ตค่าในฟอร์ม
    formaddperson.setFieldsValue({
      cuscod: "",
      snam: "",
      fname: "",
      lname: "",
      relation: "",
    }); // เคลียร์ค่าฟอร์ม
    setShowForm(false);
    setRadioValue(2);
    setAssetCustomer([]);
  };

  // ฟังก์ชันอัพโหลดรูปภาพ
  const funcUploadImages = async (resultImgs) => {
    const newFormData = new FormData();
    return new Promise(async (resolve, reject) => {
      try {
        setLoading(true);
        var status;
        newFormData.append("assetId", dataEdit?.assetId);
        newFormData.append("landAreaId", dataEdit?.landAreaId); // ถ้ามีทรัพย์ให้ส่ง id ของ asset_land_area ไปด้วย
        for (const file of resultImgs) {
          console.log("file", file);
          var image = {};
          newFormData.append("file", file.imageCompressedFile);
          newFormData.append("type", file.type);
          image.type = file.type;
        }
        const response = await axios.post(
          POST_UPLOAD_IMAGE,
          // "http://localhost:8090/api-lawyer/upload-image-area",
          newFormData,
          {
            headers: {
              Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
            },
          }
        );
        console.log("response funcUploadImages", response);
        if (response.data) {
          console.log("มีทรัพย์");
          message.success("บันทึกข้อมูลเรียบร้อย");
          handleClose();
          handleLoadDataNew(response?.data);
        }
      } catch (error) {
        console.log("error funcUploadImages", error);
      } finally {
        setLoading(false);
        console.log("OK");
      }
    });
  };
  //--------------------------------- ฟังก์ชันลบรูปภาพ -------------------------------------//
  const SuccessDelete = (placement) => {
    api.success({
      message: <b>ลบสำเร็จ</b>,
      placement,
    });
  };
  const ErrorDelete = (placement) => {
    api.error({
      message: <b>ลบไม่สำเร็จ</b>,
      placement,
    });
  };
  const showConfirmDeleteIMGGua = (value) => {
    confirm({
      title: "คุณต้องการที่จะลบรูปหรือไม่...?",
      content: "กด OK เพื่อยืนยันการลบ",
      onOk() {
        handleDeleteIMG(value);
      },
      onCancel() {
        // setSelectedImages([]); // เคลียร์ค่า
      },
    });
  };

  const handleDeleteIMG = async (value) => {
    console.log("value", value);
    // console.log("getimages", getimages);
    try {
      setLoading(true);
      const response = await axios.delete(DELETE_IMAGE, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=", // ⚠️ Hardcoded credentials
        },
        data: value,
      });
      console.log("response", response?.data);

      if (response.data) {
        console.log("res.data", response.data);
        SuccessDelete("top");
        setGetImages((prev) =>
          prev.filter(
            (item) =>
              !(
                item.imageId === value[0].imageId &&
                item.landAreaId === value[0].landAreaId &&
                item.assetId === value[0].assetId
              )
          )
        );
        setLoading(false);
      } else {
        message.error("ไม่สามารถลบข้อมูลได้"); // ⚠️ ambiguous if response.data = {}
      }
    } catch (error) {
      if (error.response) {
        console.error(
          "Server responded with error:",
          error.response.status,
          error.response.data
        );
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    } finally {
      setLoading(false); // ✅ make sure loading state resets
    }
  };

  //--------------------------------- แก้ไขเจ้าของทรัพย์ -----------------------------------//
  const handleEditOwner = (data) => {
    setModalEditOwner(true);
    setDataEditOwner(data);
  };
  //--------------------------------- ลบเจ้าของทรัพย์ -----------------------------------//
  const handleDeleteOwner = async (data) => {
    Modal.confirm({
      title: "ยืนยันการลบ",
      content: "คุณแน่ใจหรือไม่ว่าต้องการลบ 'เจ้าของทรัพย์' นี้?",
      okText: "ลบ",
      okType: "danger",
      cancelText: "ยกเลิก",
      async onOk() {
        await deleteAsset(data); // ลบ asset ที่มีทรัพย์
      },
      onCancel() {
        console.log("ยกเลิกการลบ");
      },
    });
  };
  const deleteAsset = async (data) => {
    console.log("data delete Owner", data);
    try {
      setLoading(true);
      const params = {
        landId: data?.landId,
        acId: data?.acId,
      };

      console.log("params", params);
      const response = await axios.delete(DELETE_CUSTOMER_ONE_ASSET, {
        data: params, // ✅ ต้องใช้ data
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
        },
      });
      console.log("response", response?.data);
      if (response.status === 200 || response.status === 204) {
        message.success("ลบข้อมูลเรียบร้อย");
        // ✅ อัพเดต state เอา item ที่ไม่ตรงกับ params
        setAssetCustomer((prev) =>
          prev.filter(
            (item) =>
              !(item.landId === params.landId && item.acId === params.acId)
          )
        );
      } else {
        message.error("ลบข้อมูลไม่สำเร็จ");
        console.log("ลบข้อมูลไม่สำเร็จ");
      }
    } catch (err) {
      console.log("Validation failed:", err);
      message.error("เกิดข้อผิดพลาดระหว่างการลบ");
    } finally {
      setLoading(false);
    }
  };

  //--------------------------------- เวลากดบันทึก -----------------------------------//
  const onSave = async () => {
    //16.43450331659936, 102.8252648307901
    setLoading(true);
    try {
      const values = await form.validateFields();
      console.log("values", values);
      console.log("dataEdit", dataEdit);
      const params = {
        assetLandArea: {
          ...dataEdit,
          ...values,
          contractLandCustomer: assetCustomer,
        },
        assetHasLoanId: datas ? datas?.assetHasLoanId : null,
        assetId: dataForEdit?.assetId,
        createdAt: datasendForEdit?.createdAt,
        updatedAt: datasendForEdit?.updatedAt,
        customerId: dataForEdit?.customerId,
        investigation: true, // 0=ไม่มีทรัพย์,1=มีทรัพย์
        urlPath: "", // path รูปภาพ
        userId: 888,
      };
      const AllImages = [...allImg];
      console.log("params update Data", params);
      console.log("AllImages", AllImages);

      // มีทรัพย์จะสร้างทรัพย์ก่อน (assest_land_area) และส่ง id กลับมาเพื่อบันทึกรูปภาพ
      const response = await axios.post(
        POST_EDIT_ASSET,
        //     "http://localhost:8080/api-inv/add-asset",
        params,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
          },
        }
      );
      console.log("response", response?.data);
      if (response?.data) {
        if (AllImages?.length > 0) {
          await funcUploadImages(AllImages);
        } else {
          message.success("บันทึกข้อมูลเรียบร้อย");
          handleClose();
          handleLoadDataNew(response?.data);
          handleLoadPaegeFornewData(response?.data);
        }
      } else {
        console.log("บันทึกข้อมูลไม่สำเร็จ");
        setLoading(false);
      }
    } catch (err) {
      console.log("Validation failed:", err);
    }
  };
  //--------------------------------- เวลาติ๊ก checkbox -----------------------------------//
  const handleCheckboxChange = (checkedValues) => {
    let newChecked = [...checkedValues];

    if (newChecked.includes("4")) {
      newChecked = ["4"];
    } else {
      newChecked = newChecked.filter((val) => val !== "4");
    }

    if (
      newChecked.includes("1") &&
      (newChecked.includes("2") || newChecked.includes("3"))
    ) {
      message.warning(
        "ไม่สามารถเลือก 'ติดอายัด' พร้อมกับ 'ติดจำนอง/ติดขายฝาก' ได้"
      );
      newChecked = ["1"];
    }

    if (
      (newChecked.includes("2") || newChecked.includes("3")) &&
      newChecked.includes("1")
    ) {
      message.warning(
        "ไม่สามารถเลือก 'ติดจำนอง/ติดขายฝาก' พร้อมกับ 'ติดอายัด' ได้"
      );
      newChecked = newChecked.filter((val) => val !== "1");
    }

    if (newChecked.includes("2") || newChecked.includes("3")) {
      const lastSelected = newChecked[newChecked.length - 1];
      if (lastSelected === "2" || lastSelected === "3") {
        newChecked = [lastSelected];
      }
    }

    // ✅ update ฟอร์ม
    form.setFieldsValue({ landAreaStatus: newChecked });
    handlecheckedValues(index, newChecked);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      width={1200}
      footer={null}
      title="แก้ไขทรัพย์"
    >
      <Row justify="center" gutter={[16, 16]} align="middle">
        <Col span={24} style={{ textAlign: "center", marginBottom: 4 }}>
          <Form form={formradio} layout="vertical">
            <h4>สถานะภาระทรัพย์</h4>
            <Form.Item name="landAreaStatus">
              <Checkbox.Group
                onChange={handleCheckboxChange}
                style={{ width: "100%" }}
              >
                <Row justify={"center"} gutter={[16, 16]}>
                  <Space wrap size="large">
                    <Checkbox value="1">ติดอายัด</Checkbox>
                    <Checkbox value="2">ติดจำนอง</Checkbox>
                    <Checkbox value="3">ติดขายฝาก</Checkbox>
                    <Checkbox value="4">ไม่ติดภาระ</Checkbox>
                  </Space>
                </Row>
              </Checkbox.Group>
            </Form.Item>
          </Form>
        </Col>

        {/* ---------------------------- อัพโหลดรูปภาพ ---------------------------- */}
        <Col xs={24}>
          <Divider>รูปภาพ</Divider>
          <Row justify="center" gutter={[16, 16]}>
            {/* === รูปสถานที่ === */}
            <Col xs={24} sm={12} md={8}>
              <Card
                bordered
                style={{ width: "100%" }}
                title={
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    รูปสถานที่
                  </div>
                }
              >
                <Form.Item>
                  <Image.PreviewGroup>
                    <Space size={[10, 10]} wrap>
                      {getimages
                        ?.filter((img) => img?.type === 2)
                        .map((imageData, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Image
                              width={70}
                              src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                              alt={`รูปภาพ ${index}`}
                              style={{ borderRadius: "8px" }}
                            />
                            <Button
                              danger
                              size="small"
                              type="primary"
                              onClick={() =>
                                showConfirmDeleteIMGGua([imageData])
                              }
                            >
                              ลบรูปภาพ
                            </Button>
                          </div>
                        ))}
                    </Space>
                  </Image.PreviewGroup>
                  <Row justify={"center"} style={{ marginTop: 8 }}>
                    <Upload
                      accept="image/*"
                      multiple
                      listType="picture-card"
                      fileList={fileListLocation}
                      onPreview={handlePreview}
                      onChange={(value) =>
                        handleChangeLocation(
                          value,
                          fileListLocation,
                          setFileListLocation,
                          2
                        )
                      }
                      beforeUpload={(file) =>
                        beforeUpts(file, 2)
                          .then(() => false)
                          .catch(() => true)
                      }
                    >
                      {fileListLocation?.length >= 20 ? null : (
                        <div>
                          <PlusOutlined />
                          <div>อัพโหลด</div>
                        </div>
                      )}
                    </Upload>
                  </Row>
                </Form.Item>
              </Card>
            </Col>

            {/* === รูปแผนที่ === */}
            <Col xs={24} sm={12} md={8}>
              <Card
                bordered
                style={{ width: "100%" }}
                title={
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    รูปแผนที่
                  </div>
                }
              >
                <Form.Item>
                  <Image.PreviewGroup>
                    <Space size={[10, 10]} wrap>
                      {getimages
                        ?.filter((img) => img?.type === 3)
                        .map((imageData, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Image
                              width={70}
                              src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                              alt={`รูปภาพ ${index}`}
                              style={{ borderRadius: "8px" }}
                            />
                            <Button
                              danger
                              size="small"
                              type="primary"
                              onClick={() =>
                                showConfirmDeleteIMGGua([imageData])
                              }
                            >
                              ลบรูปภาพ
                            </Button>
                          </div>
                        ))}
                    </Space>
                  </Image.PreviewGroup>
                  <Row justify={"center"} style={{ marginTop: 8 }}>
                    <Upload
                      accept="image/*"
                      multiple={true}
                      style={{ textAlign: "center" }}
                      listType="picture-card"
                      fileList={fileListMap}
                      onPreview={handlePreview}
                      onChange={(value) =>
                        handleChangeMap(value, fileListMap, setFileListMap, 3)
                      }
                      // onChange={handleChangeMap}
                      beforeUpload={(file) =>
                        beforeUpts(file, 3)
                          .then(() => false)
                          .catch(() => true)
                      }
                    >
                      {fileListMap?.length >= 20 ? null : (
                        <div>
                          <PlusOutlined />
                          <div className="ant-upload-text">upload</div>
                        </div>
                      )}
                    </Upload>
                  </Row>
                </Form.Item>
              </Card>
            </Col>
            {/* === รูปใบประเมิน === */}
            <Col xs={24} sm={12} md={8}>
              <Card
                bordered
                style={{ width: "100%" }}
                title={
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    รูปใบประเมิน
                  </div>
                }
              >
                <Form.Item>
                  <Image.PreviewGroup>
                    <Space size={[10, 10]} wrap>
                      {getimages
                        ?.filter((img) => img?.type === 4)
                        .map((imageData, index) => (
                          <div
                            key={index}
                            style={{
                              flex: "0 0 auto",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Image
                              width={70}
                              src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                              alt={`รูปภาพ ${index}`}
                              style={{ borderRadius: "8px" }}
                            />
                            <Button
                              danger
                              size="small"
                              type="primary"
                              onClick={() =>
                                showConfirmDeleteIMGGua([imageData])
                              }
                            >
                              ลบรูปภาพ
                            </Button>
                          </div>
                        ))}
                    </Space>
                  </Image.PreviewGroup>
                  <Row justify={"center"} style={{ marginTop: 8 }}>
                    <Upload
                      accept="image/*"
                      multiple={true}
                      style={{ textAlign: "center" }}
                      listType="picture-card"
                      fileList={fileListAssessment}
                      onPreview={handlePreview}
                      onChange={(value) =>
                        handleChangeAssessment(
                          value,
                          fileListAssessment,
                          setFileListAssessment,
                          4
                        )
                      }
                      beforeUpload={(file) =>
                        beforeUpts(file, 4)
                          .then(() => false)
                          .catch(() => true)
                      }
                    >
                      {fileListAssessment?.length >= 20 ? null : (
                        <div>
                          <PlusOutlined />
                          <div className="ant-upload-text">upload</div>
                        </div>
                      )}
                    </Upload>
                  </Row>
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>

        <Modal open={previewVisible} onCancel={handleCancel} footer={null}>
          <img
            alt="ตัวอย่างรูปภาพ"
            style={{ width: "100%" }}
            src={previewImage}
          />
        </Modal>
        <Divider />

        <Row justify="center" gutter={[16, 16]} style={{ width: "100%" }}>
          {/* ---------------------------- ติดอายัด ติดจำนอง ติดขายฝาก ----------------------------*/}
          <Col xs={24} md={12}>
            {ch === "1" ? ( // กรณีติดอายัด
              <Card
                size="small"
                title={
                  <div style={{ textAlign: "center" }}>
                    รายละเอียดกรณีติดอายัด
                  </div>
                }
                style={{ padding: "12px" }}
              >
                <Form
                  form={seizedForm}
                  layout="vertical"
                  initialValues={datasendForEdit[index]?.assetSeized || {}}
                  onValuesChange={(changedValues, allValues) =>
                    handleFormChange(index, "seizedData", allValues)
                  }
                >
                  <Form.Item
                    label="ชื่อเจ้าของคำพิพากษา"
                    name="judgementOwner"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกชื่อเจ้าของคำพิพากษา",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="เลขคดีแดง"
                    name="caseNumber"
                    rules={[{ required: true, message: "กรุณากรอกเลขคดีแดง" }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="ราคาประเมิน"
                    name="valuationPrice"
                    rules={[
                      { required: true, message: "กรุณากรอกราคาประเมิน" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="เจ้าพนักงานบังคับคดี"
                    name="enforcementOfficer"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกเจ้าพนักงานบังคับคดี",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="ชื่อสำนักงาน"
                    name="officeName"
                    rules={[
                      { required: true, message: "กรุณากรอกชื่อสำนักงาน" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Form>
              </Card>
            ) : ch === "2" || ch === "3" ? ( // กรณีติดจำนอง/ขายฝาก
              <Card
                size="small"
                title={
                  <div style={{ textAlign: "center" }}>
                    รายละเอียดกรณีติดจำนอง/ขายฝาก
                  </div>
                }
                style={{ padding: "12px" }}
              >
                <Form
                  form={mortgageForm}
                  layout="vertical"
                  initialValues={datasendForEdit[index]?.assetMortgage || {}}
                  onValuesChange={(changedValues, allValues) =>
                    handleFormChange(index, "mortgageData", allValues)
                  }
                >
                  <Form.Item
                    label="เจ้าหนี้จำนอง"
                    name="mortgageCreditor"
                    rules={[
                      { required: true, message: "กรุณากรอกเจ้าหนี้จำนอง" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="วันทำสัญญา"
                    name="contractDate"
                    rules={[
                      { required: true, message: "กรุณาเลือกวันทำสัญญา" },
                    ]}
                  >
                    <DatePicker style={{ width: "100%", height: "40px" }} />
                  </Form.Item>
                  <Form.Item
                    label="ยอดหนี้จำนอง"
                    name="mortgageDebt"
                    rules={[
                      { required: true, message: "กรุณากรอกยอดหนี้จำนอง" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="กำหนดไถ่ถอน"
                    name="redemptionDate"
                    rules={[
                      { required: true, message: "กรุณาเลือกกำหนดไถ่ถอน" },
                    ]}
                  >
                    <DatePicker style={{ width: "100%", height: "40px" }} />
                  </Form.Item>
                </Form>
              </Card>
            ) : (
              <Row
                justify="center"
                align="middle"
                style={{ minHeight: "100%", display: "flex" }}
              >
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Card style={{ textAlign: "center", border: "none" }}>
                    <h2>ติ๊ก checkbox สถานะภาระทรัพย์เพื่อโชว์ฟอร์ม</h2>
                  </Card>
                </Col>
              </Row>
            )}
          </Col>
          {/* ---------------------------- รายละเอียดที่ดิน ---------------------------- */}
          <Col xs={24} md={12}>
            <Card
              // title="รายละเอียดที่ดิน"
              title={
                <div style={{ textAlign: "center" }}>รายละเอียดที่ดิน</div>
              }
              style={{ padding: "12px" }}
              bordered={false}
            >
              <Form
                form={form}
                layout="vertical"
                // disabled  // ✅ ทั้งฟอร์มแก้ไม่ได้
                // initialValues={guarantorAssetData[index] || {}}
                onValuesChange={handleFormChanges}
              >
                <Row justify={"center"}>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="เลขที่ดิน"
                      name="numberLand"
                      rules={[
                        { required: true, message: "กรุณากรอกเลขที่ดิน" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="เลขระวาง"
                      name="numberLandlawang"
                      rules={[{ required: true, message: "กรุณากรอกเลขระวาง" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "left" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="จังหวัด"
                      name="provinceName"
                      rules={[{ required: true, message: "กรุณากรอกจังหวัด" }]}
                    >
                      <Select
                        placeholder="เลือกจังหวัด"
                        onChange={handleProvinceChange}
                        // value={provinc}
                        style={{ height: "40px" }}
                      >
                        {provinces?.map((prov) => (
                          <Option key={prov.id} value={prov.prov_code}>
                            {prov.prov_desc}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "left" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="อำเภอ"
                      name="districtName"
                      rules={[{ required: true, message: "กรุณากรอกอำเภอ" }]}
                    >
                      <Select
                        placeholder="เลือกอำเภอ"
                        onChange={handleDistrictChange}
                        style={{ height: "40px" }}
                      >
                        {districts?.map((d) => (
                          <Option key={d.dist_code} value={d.dist_code}>
                            {d.dist_desc}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "left" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ตำบล"
                      name="subdistrictName"
                      rules={[{ required: true, message: "กรุณากรอกตำบล" }]}
                    >
                      <Select
                        placeholder="เลือกตำบล"
                        onChange={handleSubdistrictChange}
                        style={{ height: "40px" }}
                      >
                        {subdistricts?.map((s) => (
                          <Option key={s.sub_dist_code} value={s.sub_dist_code}>
                            {s.sub_dist_desc}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="รหัสไปรษณีย์"
                      name="zipcode"
                      rules={[
                        { required: true, message: "กรุณากรอกรหัสไปรษณีย์" },
                      ]}
                    >
                      <Input value={zipcode} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ราคาที่ดิน"
                      name="landPrice"
                      rules={[
                        { required: true, message: "กรุณากรอกราคาที่ดิน" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ชื่อสถานที่"
                      name="nameMap"
                      rules={[
                        { required: true, message: "กรุณากรอกชื่อสถานที่" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ละติจูด"
                      name="lat"
                      rules={[{ required: true, message: "กรุณากรอกละติจูด" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ลองจิจูด"
                      name="lng"
                      rules={[{ required: true, message: "กรุณากรอกลองจิจูด" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
        <Divider style={{ margin: 5 }} />
        {/* ---------------------------- เจ้าของทรัพย์ -------------------------- */}
        <Row justify={"center"} gutter={[16, 16]} style={{ width: "100%" }}>
          <Col span={24} style={{ textAlign: "center", marginBottom: 4 }}>
            {assetCustomer?.length > 0 ? (
              <>
                <h4
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginBottom: "12px",
                  }}
                >
                  เจ้าของทรัพย์ที่มี
                </h4>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "8px",
                  }}
                >
                  {assetCustomer?.map((owner, idx) => {
                    console.log("owner", owner);
                    return (
                      <Card
                        key={idx}
                        bordered
                        style={{
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                          padding: "12px",
                          marginBottom: "12px",
                          width: "350px",
                        }}
                      >
                        {owner?.assetType === 2 && (
                          <p
                            style={{
                              color: "#1677ff",
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            📍 สืบลงพื้นที่
                          </p>
                        )}

                        <p>
                          <b>ชื่อ - สกุล :</b>{" "}
                          {owner?.assetCustomer?.snam || "-"}{" "}
                          {owner?.assetCustomer?.fname || "-"}{" "}
                          {owner?.assetCustomer?.lname || "-"}
                        </p>
                        <p>
                          <b>ความสัมพันธ์:</b> {owner?.relation || "-"}
                        </p>
                        <Divider />
                        <Row justify="center">
                          <Space>
                            <Button
                              danger
                              onClick={() => handleDeleteOwner(owner)}
                            >
                              🗑️ ลบ
                            </Button>
                            <Button
                              type="primary"
                              onClick={() => handleEditOwner(owner)}
                            >
                              ✏️ แก้ไข
                            </Button>
                          </Space>
                        </Row>
                      </Card>
                    );
                  })}
                </div>
              </>
            ) : null}
          </Col>
        </Row>
        <h4 style={{ fontSize: "18px", fontWeight: "700" }}>
          เพิ่มเจ้าของทรัพย์ (กรณีทรัพย์ที่ไปสืบไม่ตรงกับในระบบ)
        </h4>
        <Col span={24} style={{ textAlign: "center" }}>
          <Radio.Group
            onChange={(e) => setRadioValue(e.target.value)} // เก็บค่าที่เลือก
            value={radioValue}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Radio value={1} style={{ fontSize: "18px", fontWeight: "700" }}>
              ใช่
            </Radio>
            <Radio value={2} style={{ fontSize: "18px", fontWeight: "700" }}>
              ไม่ใช่
            </Radio>
          </Radio.Group>
        </Col>
        {/* ---------------------------- เพิ่มเจา้ของทรัพย์ ---------------------------- */}
        <Row justify="center" style={{ margin: 8 }}>
          <Col span={24} style={{ textAlign: "center" }}>
            {radioValue === 1 && (
              <Button
                type="primary"
                size="large"
                onClick={() => setShowForm(!showForm)}
              >
                เพิ่มเจ้าของทรัพย์
              </Button>
            )}
          </Col>
          {showForm && radioValue === 1 && (
            <Card style={{ width: "100%", margin: "16px auto" }}>
              <Form form={formaddperson} layout="vertical" onFinish={onFinish}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label="รหัสลูกค้า (cuscod)"
                      name="cuscod"
                      rules={[
                        { required: true, message: "กรุณากรอกรหัสลูกค้า" },
                        {
                          pattern: /^[0-9]{1,13}$/,
                          message: "กรุณากรอกเป็นตัวเลข ไม่เกิน 13 หลัก",
                        },
                      ]}
                    >
                      <Input maxLength={13} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label="คำนำหน้า (snam)"
                      name="snam"
                      rules={[
                        { required: true, message: "กรุณาเลือกคำนำหน้า" },
                      ]}
                    >
                      <Select style={{ height: "40px" }}>
                        <Option value="นาย">นาย</Option>
                        <Option value="นาง">นาง</Option>
                        <Option value="นางสาว">นางสาว</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label="ชื่อจริง (fname)"
                      name="fname"
                      rules={[{ required: true, message: "กรุณากรอกชื่อจริง" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label="นามสกุล (lname)"
                      name="lname"
                      rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label="ความสัมพันธ์ (relation)"
                      name="relation"
                      rules={[
                        { required: true, message: "กรุณากรอกความสัมพันธ์" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"end"}>
                  <Space>
                    <Button
                      danger
                      style={{
                        background: "red",
                        color: "white",
                        textAlign: "center",
                      }}
                      onClick={onCancels}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึกเจ้าของทรัพย์
                    </Button>
                  </Space>
                </Row>
              </Form>
            </Card>
          )}
        </Row>
        {/* ---------------------------- ปุ่มบันทึกข้อมูล ---------------------------- */}
        <Row justify="center" gutter={[16, 16]} style={{ width: "100%" }}>
          <div style={{ textAlign: "right", margin: 8 }}>
            <Space>
              <Button
                style={{ background: "red", color: "white" }}
                size="large"
                onClick={handleClose}
              >
                ปิด
              </Button>
              <Button
                type="primary"
                size="large"
                // disabled={!guarantorAssetData[index]?.asset}
                onClick={onSave}
              >
                บันทึกข้อมูล
              </Button>
            </Space>
          </div>
        </Row>
      </Row>

      <Divider style={{ margin: 5 }} />
      {modaleditowner ? (
        <ModalEditOwner
          open={modaleditowner}
          close={setModalEditOwner}
          dataeditowner={dataeditowner}
          handledataNewOwner={handledataNewOwner}
        />
      ) : null}
      {contextHolder}
    </Modal>
  );
}

export default ModalAssetForEdit;
